export enum ToastStatus {
  SUCCESS = 'success',
  DANGER = 'danger',
  WARNING = 'warning',
  INFO = 'info',
}

export enum ToasterMessages {
  ACCOUNT_DISABLED_MESSAGE = 'You are inactivated by the principal user, you cannot login to the system!',
  CLASSROOM_NOT_FOUND_MESSAGE = 'No classroom found. The code might be incorrect or belong to a different year or school.',
  ACADEMIC_YEAR_DISABLED_MESSAGE = 'You cannot change the academic year on this page.',
  YEAR_CHANGED_DURING_ASSESSMENT_MESSAGE = 'You cannot change academic year during attempting an assessment.',
  SCHOOL_HEADER_DISABLED_MESSAGE = 'You cannot change the school on this page.',
}
